module.exports = __webpack_public_path__ + "static/img/twin-highway-3.47c5e795.png";